<script>
    import { _ } from '../services/i18n'
    export let orderId = 0;
    export let sceneId = 0;

    import config from "../config";
</script>

<div class="btn-container">
  
    <!-- svelte-ignore security-anchor-rel-noreferrer -->
    <a class="AddToCartButton" href={`/sim3d.html#/load/order/${orderId}/${sceneId}`} target="_blank">
        {$_('order_options_orderBy_addToNewScene')} <!-- <img src="/icons/carrito.svg" class="viewer-logo" alt="3DViewer"> --> 
       
    </a>
</div>

<style>
    .btn-container {
    width: fit-content;
    float: left;
    position: relative;
    }

    .AddToCartButton {
        float: right;
        border-radius: 5px;
        margin: 5px 0;
        background-color: var(--theme-color-1);
        color: #fff;
        border: 0 none;
        padding: 5px  7px;
        text-align: center;
        width:fit-content;
        position: relative;
        transition: all 0.25s ease-in-out;
        font-size: 8px;
    }

    /* .AddToCartButton img.viewer-logo {
        width: 22px !important;
        height: 22px !important;
        border: none;
    } */

    .AddToCartButton:hover {
        background-color: var(--theme-color-4);
        color: #fff;
    }

    .AddToCartButton:hover:before {
        background-color: var(--theme-color-4);
    }
        
    .AddToCartButton:hover:after {
        background-color: var(--theme-color-4);
    }
    .AddToCartButton:before,
    .AddToCartButton:after {
        content: "";
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        background-color: var(--theme-color-1);
        width: 100%;
        height: 100%;
        border-radius: 5px;
        opacity: 0;
        transition: all 0.25s ease-in-out;
    }
    a:hover {
    text-decoration: none;
       }
    @-webkit-keyframes AddToCartButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
    @keyframes AddToCartButton-beat {
        0% {
            opacity: 0.8;
            transform: scale(1);
        }
        70% {
            opacity: 0;
            transform: scale(1.5);
        }
        100% {
            opacity: 0;
        }
    }
</style>

<svelte:head>
    <script src="https://unpkg.com/jspdf@latest/dist/jspdf.umd.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js" integrity="sha512-BNaRQnYJYiPSqHHDb58B0yaPfCu+Wgds8Gp/gU33kqBtgNS4tSPHuGibyoeqMV/TJlSKda6FXzoEyYGjTe+vXA==" crossorigin="anonymous" referrerpolicy="no-referrer"></script>
</svelte:head>